import { apiStatus } from '@va/constants';
import { AccountInformationType } from '@va/types/account';
import Immutable from 'immutable';

export const getAccountInformation = (state: any) =>
  state.getIn(['core', 'api', 'accountInformation'], Immutable.Map()).toJS() as AccountInformationType & {
    status: apiStatus;
  };
